export const DATA_TEST_IDS = {
  toastVivicaSupport: 'toasts__error_unknown-error',
};
